import { Modal, ModalBody, ModalContent, ModalHeader } from "@nextui-org/react";
import FileViewer from "../../../components/UI/FileViewer";

interface PDFViewerProps {
    openModal: boolean;
    onClose: () => void;
    url: string;
}

const PDFViewer:React.FC<PDFViewerProps> = ({openModal, onClose, url}) => {
    return (
        <Modal
            size="5xl"
            backdrop="blur"
            isOpen={openModal}
            onClose={onClose}
            motionProps={
                {
                    variants: {
                        enter: {
                        y: 0,
                        opacity: 1,
                        transition: {
                            duration: 0.3,
                            ease: "easeOut",
                        },
                        },
                        exit: {
                        y: -20,
                        opacity: 0,
                        transition: {
                            duration: 0.2,
                            ease: "easeIn",
                        },
                        },
                    },
                }
            }
        >
            <ModalContent>
                <ModalHeader className="flex flex-col gap-1">Vista previa</ModalHeader>
                <ModalBody>
                    <FileViewer url={url} height="500px"/>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

export default PDFViewer;